<template>
    <header id="header">
        <div class="logo" @click="doBigScreen">
            Enviro Sound <i id="fullscreen" class="mdi mdi-fullscreen"></i><!--router-link to="/">Vue - Complete Guide</router-link-->
        </div>
        <nav>
          <ul>
            <li>
                <button @click="onSound" class="options"><i class="mdi mdi-ear-hearing"></i><div class="small">Sounds</div></button>
            </li>
            <li>
                <button @click="onImage" class="options"><i class="mdi mdi-image-area"></i><div class="small">Images</div></button>
            </li>
            <li>
                <button @click="onHideAll" class="options"><i class="mdi mdi-eye-off-outline"></i><div class="small">Hide all</div></button>
            </li>
          </ul>
        </nav>
    </header>
</template>

<script>
    export default {
        data() {
            return {
                fs: false,
                elem: document.body,   // Make the body go full screen.
                doc_height: 0
            }
        },
        methods: {
            onSound() {
                if(this.$parent.visibleOn == 2) {
                    $( "#wallpapers" ).hide( "slow" );
                } else if(this.$parent.visibleOn == 3) {
                    $( "#cookiestext" ).hide( "slow" );
                }
                $( "#main" ).show( "slow" );
                $( "button" ).blur();
                $( "#header" ).css({'background-color': 'rgb(82, 23, 81)'});
                $( ".options" ).css({'color': '#ffffff'});
                $( ".logo" ).css({'color': '#ffffff'});
                this.$parent.visibleOn = 1;
            },
            onImage() {
                if(this.$parent.visibleOn == 1) {
                    $( "#main" ).hide( "slow" );
                } else if(this.$parent.visibleOn == 3) {
                    $( "#cookiestext" ).hide( "slow" );
                }
                $( "#wallpapers" ).show( "slow" );
                $( "button" ).blur();
                $( "#header" ).css({'background-color': 'rgb(82, 23, 81)'});
                $( ".options" ).css({'color': '#ffffff'});
                $( ".logo" ).css({'color': '#ffffff'});
                this.$parent.visibleOn = 2;
            },
            onHideAll() {
                if(this.$parent.visibleOn == 1) {
                    $( "#main" ).hide( "slow" );
                } else if(this.$parent.visibleOn == 2) {
                    $( "#wallpapers" ).hide( "slow" );
                } else if(this.$parent.visibleOn == 3) {
                    $( "#cookiestext" ).hide( "slow" );
                }
                $( "button" ).blur();
                $( "#header" ).css({'background-color': 'rgba(82, 23, 81, 0.3)'});
                $( ".options" ).css({'color': '#ffffff85'});
                $( ".logo" ).css({'color': '#ffffff85'});
                this.$parent.visibleOn = 4;
            },
            doBigScreen() {
                this.fs = !this.fs;
                if (this.fs) {
                    $( ".mdi-fullscreen").addClass("mdi-fullscreen-exit");
                    $( ".mdi-fullscreen").removeClass("mdi-fullscreen");
                    if (this.elem.requestFullscreen) {
                        this.elem.requestFullscreen();
                        $( "body:fullscreen" ).css({'background-color': 'red'});
                    } else if (this.elem.mozRequestFullScreen) { /* Firefox */
                        this.elem.mozRequestFullScreen();
                        $( "body:-moz-full-screen]" ).css({'background-color': 'red'});
                    } else if (this.elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                        this.elem.webkitRequestFullscreen();
                        $( ":-webkit-full-screen" ).css({'background-color': 'red'});
                    } else if (elem.msRequestFullscreen) { /* IE/Edge */
                        this.elem.msRequestFullscreen();
                        $( ":-ms-fullscreen" ).css({'background-color': 'red'});
                    }
                    this.doc_height = window.innerHeight;
                    console.log(this.doc_height);
                } else {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) { /* Firefox */
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE/Edge */
                        document.msExitFullscreen();
                    }
                    $( ".mdi-fullscreen-exit").addClass("mdi-fullscreen");
                    $( ".mdi-fullscreen-exit").removeClass("mdi-fullscreen-exit");

                    console.log(this.doc_height);
                }
                /*
                    /* Chrome, Safari and Opera syntax *
                    :-webkit-full-screen {
                    background-color: yellow;
                    }

                    /* Firefox syntax *
                    :-moz-full-screen {
                    background-color: yellow;
                    }

                    /* IE/Edge syntax *
                    :-ms-fullscreen {
                    background-color: yellow;
                    }

                    /* Standard syntax *
                    :fullscreen {
                    background-color: yellow;
                    }
                */
            }
        }
    }
</script>

<style scoped>
    #header {
        height: 56px;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        align-items: center;
        background-color: #521751;
        padding: 0 20px;
    }

    .logo {
        font-weight: bold;
        font-size: 1rem;
        color: white;
        cursor: pointer;
    }

    .logo a {
        text-decoration: none;
        color: white;
    }

    nav {
        height: 100%;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        height: 100%;
        display: flex;
        flex-flow: row;
        align-items: center;
    }

    li {
        margin: 0 16px;
    }

    li a {
        text-decoration: none;
        color: white;
    }

    li a:hover,
    li a:active,
    li a.router-link-active {
        color: #fa923f;
    }
    small,
    .small {
        font-size: 0.7rem;
    }
    br {
        font-size: 0.2rem;
    }
    .options {
        font-size: 1.3rem !important;
        padding: 0px;
        background-color: transparent;
        border: none;
        font: inherit;
        color: white;
        cursor: pointer;
    }
    @media screen and (max-width: 560px) {
        .logo {
            font-size: 0.8rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/links/Header.vue